'use strict';

const { queryFirst } = require('../domUtil');
const { NOT_AVAILABLE_STATUS, PREORDER_STATUS } = require('../constants');
const { PDPNarvarEDD } = window.johnnyWasUtils;
const isEDDEnabled = !!PDPNarvarEDD;

const EDD_INFO_SELECTOR = '.narvar-edd-info';

/**
 * Function to inject Estimated delivery date message into its container
 * @param {HTMLElement} productContainerEl - Product container element
 */
function injectEDDInfo(productContainerEl) {
    if (!isEDDEnabled || !productContainerEl) return;

    const eddEl = queryFirst(EDD_INFO_SELECTOR, productContainerEl);
    if (eddEl) eddEl.innerHTML = PDPNarvarEDD.estimatedDeliveryTime;
}

/**
 * Function to remove Estimated delivery date message from its container
 * @param {HTMLElement} productContainerEl - Product container element
 */
function removeEDDInfo(productContainerEl) {
    if (!isEDDEnabled || !productContainerEl) return;

    const eddEl = queryFirst(EDD_INFO_SELECTOR, productContainerEl);
    if (eddEl) eddEl.textContent = '';
}

/**
 * Function to check if Estimated delivery messages to be displayed or not for that variant
 * @param {string} availabilityStatus - Product container element
 * @return {boolean} - if EDD is applicable for a variant, it returns true, else returns false
 */
function isEDDApplicable(availabilityStatus) {
    return (availabilityStatus !== PREORDER_STATUS && availabilityStatus !== NOT_AVAILABLE_STATUS);
}

module.exports = {
    isEDDApplicable,
    injectEDDInfo,
    removeEDDInfo
};
